const CounterTestIds = {
  ADD_TO_CART_BUTTON: 'Counter__add-to-cart-btn',
  UPDATE_CART_BUTTON: 'Counter__update-to-cart-btn',
};

export default CounterTestIds;
